/**
 * Utility to wrap the last word of an element in a span for styling
 * @param {string} selector - CSS selector for the element
 * @param {string} className - Class name to add to the span wrapping the last word
 */
export const colorLastWord = (selector, className = 'green-word') => {
  if (typeof document === 'undefined') return; // Guard for SSR

  const element = document.querySelector(selector);
  if (!element) return;

  const text = element.textContent || element.innerText;
  if (!text) return;

  const words = text.trim().split(' ');
  if (words.length < 2) return; // Need at least 2 words

  const lastWord = words.pop();
  const remainingText = words.join(' ');

  element.innerHTML = `${remainingText} <span class="${className}">${lastWord}</span>`;
};

/**
 * Color specific words in an element with a custom class
 * @param {string} selector - CSS selector for the element
 * @param {string} wordsToColor - Words to wrap in a span
 * @param {string} className - Class name to add to the span
 */
export const colorSpecificWords = (selector, wordsToColor, className) => {
  if (typeof document === 'undefined') return; // Guard for SSR

  const elements = document.querySelectorAll(selector);
  if (!elements || elements.length === 0) return;

  // Escape special regex characters and handle multiple spaces
  const escapedWords = wordsToColor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
  const regex = new RegExp(`(${escapedWords})`, 'gi');

  elements.forEach(element => {
    const text = element.textContent || element.innerText;
    if (!text) return;

    // Only apply if the text contains the words we're looking for
    if (regex.test(text)) {
      element.innerHTML = text.replace(regex, `<span class="${className}">$1</span>`);
    }
  });
};

/**
 * Apply color to last word when DOM is ready
 */
export const initColorLastWord = () => {
  if (typeof window === 'undefined') return; // Guard for SSR

  const applyStyles = () => {
    // Color the last word "categoria" in the section-2 header h2
    colorLastWord('#section-2 header h2', 'gradient-text');

    // Color "Achei Brasil" with gradient
    colorSpecificWords('#section-5 header h2', 'Achei Brasil', 'gradient-text');

    // Color "empresas e profissionais brasileiros" with gradient in h1
    colorSpecificWords('h1', 'empresas e profissionais brasileiros', 'gradient-text');

    // Color "negócio ou oferece serviços?" with gradient in h2
    colorSpecificWords('h2', 'negócio ou oferece serviços?', 'gradient-text');

    colorSpecificWords('h1', 'empresas e profissionais', 'gradient-text')

    colorSpecificWords('h3', 'Achei Brasil?', 'green-word')

    colorSpecificWords('h3', 'nasceu para simplificar a vida dos brasileiros', 'gradient-text')

    colorSpecificWords('h2', 'plano ideal para você', 'gradient-text')

    // Style "/ mes" in pricing h3 with smaller, lighter text
    colorSpecificWords('#section-pricing h3', '/ mes', 'pricing-period')

    colorSpecificWords('h3', 'avaliacoes', 'gradient-text')

    colorSpecificWords('h3', 'Recomendadas Achei Brasil', 'gradient-text')

    colorSpecificWords('h2', 'avaliacoes', 'green-word')
  };

  // Apply on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStyles);
  } else {
    applyStyles();
  }

  // Also apply after a small delay to catch dynamically loaded content
  setTimeout(applyStyles, 500);
};
